import '../../styles/University/universityCover.scss';
import univ  from '../../assets/university-img.svg';

export const UniversityCover = () => {
  return (
    <div className='university'>
    <div className='university-container'>
        <div className='university-content'>
            <h2 data-aos="fade-up" data-aos-delay="200" data-aos-duration="800" data-aos-easing="ease-out">
                Desarrollá tu perfil profesional
            </h2>
            <p data-aos="fade-up" data-aos-delay="400" data-aos-duration="800" data-aos-easing="ease-out">
                Capacitate con nuestros cursos y talleres para mejorar tu perfil profesional.
            </p>
            <a data-aos="fade-up" data-aos-delay="600" data-aos-duration="800" data-aos-easing="ease-out" href="https://serendipiauniversity.com/" className='button btn-secondary' target='_blank' rel="noreferrer">
                Ir a University
            </a>
        </div>
        <div className='university-img' data-aos="zoom-in" data-aos-delay="600" data-aos-duration="1000" data-aos-easing="ease-out">
            <img src={univ} alt='University' />
        </div>
    </div>
</div>

  )
}
